import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AloneBuilder } from '../../components/AloneBuilder';
import { MultipleBuilders } from '../../components/MultipleBuilders';
import { IBuilder } from '../../types/newbuilding';
import { TTypedThunkDispatch } from '../../types/thunk';
import { trackingActionToCardDeveloper } from '../../actions/analytics';
import { MultipleBuildersModal } from '@cian/frontend-newbuilding-sellers-info-components';
import { trackPromoSnippetBuilderClick } from '../PromoSnippetContainer/tracking';
import { getCurrentJsonQuery } from '../../selectors/location';

interface IBuilderInfoProps {
  builders: IBuilder[];
  isPromoSnippet?: boolean;
  newbuildingId?: number;
}

export function BuilderInfo({ builders = [], isPromoSnippet = false, newbuildingId }: IBuilderInfoProps) {
  const dispatch = useDispatch<TTypedThunkDispatch>();
  const isAloneBuilder = builders.length === 1;

  const jsonQuery = useSelector(getCurrentJsonQuery);

  const [isInfoModalOpen, setIsInfoModalOpen] = React.useState(false);

  const handleInfoClick = React.useCallback(() => {
    setIsInfoModalOpen(true);
  }, []);

  const handleModalClose = React.useCallback(() => {
    setIsInfoModalOpen(false);
  }, []);

  const trackingToCardDeveloper = React.useCallback(() => {
    if (isPromoSnippet) {
      trackPromoSnippetBuilderClick(newbuildingId as number, jsonQuery);
    }

    dispatch(trackingActionToCardDeveloper());
  }, [dispatch, isPromoSnippet, newbuildingId, jsonQuery]);

  if (!builders.length) {
    return null;
  }

  return (
    <>
      {isAloneBuilder && (
        <AloneBuilder builder={builders[0]} onBuilderClick={trackingToCardDeveloper} isPromoSnippet={isPromoSnippet} />
      )}
      {!isAloneBuilder && (
        <>
          <MultipleBuilders
            builders={builders}
            onBuilderClick={trackingToCardDeveloper}
            onInfoClick={handleInfoClick}
            isPromoSnippet={isPromoSnippet}
          />
          <MultipleBuildersModal open={isInfoModalOpen} onClose={handleModalClose} />
        </>
      )}
    </>
  );
}
